import gql from 'graphql-tag'
import {EgovProcedureStatuses, EgovProcedureSignRequirement} from 'consts/egovProcedureStatuses'

export interface QueryVariables {
  statuses: EgovProcedureStatuses[]
  keyword?: string
  officeIds?: number[]
  page?: number
  limit?: number
}

export const EGOV_PROCEDURES = gql`
  query ($statuses: [EgovV1EgovProcedureStatus!], $keyword: String, $page: Int, $limit: Int) {
    client {
      egovCertificateFile {
        name
      }
      egovProcedures(statuses: $statuses, keyword: $keyword, page: $page, limit: $limit) {
        totalCount
        list {
          id
          status
          isApplicatable
          formName
          procedureName
          submissionDestination
          isDeletable
          signRequirement
          attachments {
            id
            fileName
            fileUrl
            documentName
            printedMynumber
          }
          procedureStatus {
            id
            procedureType
            employee {
              displayFirstName
              displayLastName
            }
          }
          office {
            id
            name
          }
          application {
            sendNumber
            appliedAt
            documents {
              sendNumber
            }
            comments {
              sendNumber
            }
          }
          egovApplication {
            arriveId
            appliedAt
            officialDocuments {
              id
            }
            notices {
              id
            }
            trackingLogStatus
          }
          csvProcedure {
            id
            procedureName
            employees {
              id
              displayFirstName
              displayLastName
            }
          }
        }
      }
    }
    egovAccount {
      id
      egovIdp
      gbizidAccountType
    }
  }
`

export interface EgovCertificateFile {
  name: string
}

export interface EgovProcedure {
  id: string
  formName: string
  status: EgovProcedureStatuses
  application: Application | null
  egovApplication: EgovApplication | null
  procedureName: string
  procedureStatus?: ProcedureStatus
  office: Office
  attachments: Attachment[]
  submissionDestination: string
  isDeletable: boolean
  csvProcedure: CsvProcedure
  signRequirement: EgovProcedureSignRequirement
}

export interface EgovAccount {
  id: string
  egovIdp: string
  gbizidAccountType: string
}

interface Attachment {
  id: string
  fileName: string
  fileUrl: string
  documentName: string
  printedMynumber: boolean
}

interface Application {
  sendNumber: string
  appliedAt: string
  documents: Document[]
  comments: Comment[]
}

interface Document {
  sendNumber: string
}

interface Comment {
  sendNumber: string
}

interface EgovApplication {
  arriveId: string
  appliedAt: string
  officialDocuments: OfficialDocument[]
  notices: Notice[]
  trackingLogStatus: 'SUCCESS' | 'INVALID_TOKEN' | 'ABORT' | 'TRACKING_LOG_STATUS_UNKNOWN'
}

interface OfficialDocument {
  id: string
}

interface Notice {
  id: string
}

interface Office {
  id: number
  name: string
}

interface ProcedureStatus {
  id: number
  procedureType: string
  employee: Employee
}

interface Employee {
  displayFirstName: string
  displayLastName: string
}

export interface CsvProcedure {
  id: string
  procedureName: string
  employees: [Employee]
}
